import { useEffect, useRef, useState } from "react";
import { Settings } from "lucide-react";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import { ghostBtnClass } from "@/components/common/surfaceClasses";
import { AudienceDataConsentCard } from "@/components/audience-data/AudienceDataConsentCard";
import type { SsdConsentLink } from "@/lib/ssdSalesClient";

export function AudienceDataSettingsMenu(props: {
  links: SsdConsentLink[];
  sharing: boolean;
  onSetShare: (relationshipId: string, share: boolean) => Promise<boolean>;
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  if (props.links.length === 0) return null;

  return (
    <div ref={rootRef} className="relative shrink-0">
      <button
        type="button"
        className={`inline-flex items-center justify-center ${ghostBtnClass}`}
        aria-label="Audience Data settings"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        {...{ [FIREFLY_TARGET_ATTR]: "audience-data-settings" }}
      >
        <Settings className="h-4 w-4" aria-hidden />
      </button>
      {open ? (
        <div className="absolute right-0 z-20 mt-1 w-80 max-w-[calc(100vw-2rem)] rounded-xl border border-gray-200 bg-white p-3 shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
          <p className="mb-2 text-sm font-semibold text-gray-900 dark:text-zinc-100">Share end customers</p>
          <p className="mb-3 text-xs text-gray-600 dark:text-zinc-400">
            Dealer-controlled. Manufacturers see end-customer identity only when this is on.
          </p>
          <AudienceDataConsentCard
            links={props.links}
            sharing={props.sharing}
            onSetShare={props.onSetShare}
            bare
          />
        </div>
      ) : null}
    </div>
  );
}
